module.exports = __webpack_public_path__ + "media/warranty-claim/shingle-sample2-67439c95.png";